import React from 'react';

import FooterContainer from 'containers/footer/FooterContainer'
import { default as Navbar } from 'containers/navbar/NavbarContainer'

export default () => (
  <div className="fullheight">

    <Navbar className="dark_start"/>

    <section className="boxes themeBG">
        <div className="container-fluid">
        <div className="row">
            <div className="col-md-6 p-30 p-b-60 m-t-120">
                <h3>Okavango</h3>
                <p>
                    The Table Mountain, recently named as one of the new 7 wonders of the world, is an iconic formation that projects
                    out of the earth’s surface and stands erect, as one of the world’s amazing sculptures of nature. This 600 years old
                    sandstone formation is splendid to gaze at, it is invigorating to hike on, it is amazing to ride a cable-car on.
                    It is awe-striking to see the Indian and the Atlantic Ocean meet, fight or wave along beneath it.
                    The renewing breeze and the exhilarating feeling of being on top this natures’ wonder, while at the same time
                    being mesmerized by the beautiful waters of the ocean waving along gently in the ocean below,
                    just slightly kissing, truly touches your soul.
                    The city below, built with skill and desire to impress, might just make you wonder why you did not
                    think of taking this trip this before. Well! It’s never too late, you can always come back,
                    you are most welcome here, bring your family and friends so they can experience the beauty of life and
                    the wonders of the world we all call home. Here is a glimpse of Table Mountain in pictures. See now and then
                    actually experience when you come along with us.
                </p>

            </div>
            </div>
        </div>
    </section>
    <FooterContainer />
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/details/okavango/OkavangoDetails.jsx